export const RANDOM = {
    get id() {
        return Math.random().toString(16);
    },
};

export const allTypes = [
    { id: RANDOM.id, title: 'Вебинар' },
    { id: RANDOM.id, title: 'Семинар' },
    { id: RANDOM.id, title: 'Тренинг' },
    { id: RANDOM.id, title: 'Супервизия' },
    { id: RANDOM.id, title: 'Мастер-класс' },
    { id: RANDOM.id, title: 'Доклад' },
    { id: RANDOM.id, title: 'Конференция' },
    { id: RANDOM.id, title: 'Презентация' },
    { id: RANDOM.id, title: 'Форум' },
]